export default __webpack_public_path__ + "static/media/price.41a0b3de.svg";